<script setup lang="ts">
import type { AgentOnList } from '~~/shared/agent/types';

defineProps<{
  agent: AgentOnList
}>();

const emit = defineEmits<{
  contact: []
}>();
</script>

<template>
  <div
    class="hidden lg:flex items-center justify-between w-full"
  >
    <AgentAvatarNavigation
      :agent
      class="flex-1"
    />
    <div class="flex gap-s flex-none">
      <IadBtn
        size="large"
        @click="emit('contact')"
      >
        <Icon name="iad-icon:mail" />
        {{ $t(`agent.navigation.contact_cta_short`) }}
      </IadBtn>
      <AgentBtnPhone
        size="large"
        :agent
      />
    </div>
  </div>

  <ClientOnly>
    <AgentNavigationFixed
      :agent
      @contact="emit('contact')"
    />
  </ClientOnly>
</template>
